import React from 'react'
import { Text, View } from 'oio-react'
// import { SpringOutline24Icon } from 'assets/icons' // Kept for future use PR #803
import { useGlobalState } from 'src/sites/state'
import HomeCoverVideo from './CoverVideo'

const MotherHome = () => {
   const { theme } = useGlobalState()

   return (
      <View
         backgroundColor="#f5f4eb"
         minHeight="100vh"
         marginTop={theme.viewportMarginTop}
         paddingHorizontal={`
            ${theme.tmpViewportPaddingD}[d]
            ${theme.tmpViewportPaddingE}[e]
            ${theme.tmpViewportPaddingF}[f]
         `}>
         <View
            width="100%"
            height="95vh[a-c] 85vh[d-f]">
            <View
               position="relative"
               width="100%"
               height="100%"
               borderRadius="4px[d-f]"
               backgroundColor="#030d08"
               style={{ overflow: 'hidden' }}>
               <HomeCoverVideo />
               <View
                  position="absolute"
                  width="100%"
                  height="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  padding="40px 30px 20px 30px">
                  {/* TODO: Use this when we improve website - PR #803
                  <View
                     display="none"
                     width="100%"
                     paddingRight="0%"
                     borderTop="1px solid rgba(255,255,255,0.1)">
                     <View
                        borderRight="1px solid rgba(255,255,255,0.1)"
                        flex="0 0 auto"
                        paddingTop="30px"
                        paddingBottom="30px"
                        paddingRight="180px">
                        <Text
                           fontFamily="replica-mono"
                           transform="uppercase"
                           size="1"
                           lineHeight="140%"
                           weight="bold"
                           letterSpacing="0.5px"
                           color="#fff">
                           Spring 2021
                           <br />
                           <span style={{ opacity: 0.5 }}>
                              Volumne 2
                           </span>
                        </Text>
                        <View paddingTop="5px" paddingRight="20px">
                           <SpringOutline24Icon
                              width="18px"
                              height="18px"
                              color="rgba(255,255,255,0.3)"
                           />
                        </View>
                     </View>
                     <View
                        paddingTop="30px"
                        paddingLeft="40px"
                        paddingBottom="30px"
                        paddingRight="300px">
                        <View marginBottom="5px">
                           <Text
                              size="2.5"
                              lineHeight="160%"
                              color="rgba(255,255,255,0.9)">
                              {'We are Mother Company. We are a multidisciplinary design studio.'}
                           </Text>
                        </View>
                        <Text
                           fontFamily="classico-urw"
                           size="2.5"
                           lineHeight="160%"
                           color="rgba(255,255,255,0.4)">
                           {'After a year and a half of having our heads-down building
                           new products, we have re-launch into the world. We are a
                            multidisciplinary design studio with a passion for crafting
                            personal products that people use every day for life and work. '}
                        </Text>
                     </View>
                  </View> */}
                  <View
                     display="flex"
                     flexFlow="column"
                     alignItems="center"
                     maxWidth="500px"
                     textAlign="center">
                     <View flex="0 0 auto" paddingLeft="4px">
                        <Text
                           fontFamily="replica-mono"
                           transform="uppercase"
                           size="2.5[a-b] 4[c-f]"
                           lineHeight="140%"
                           weight="bold"
                           letterSpacing="5px"
                           color="#fff">
                           Mother Company
                        </Text>
                     </View>
                     <View
                        margin="10px 0"
                        display="inline-block"
                        width="1px"
                        height="30px"
                        backgroundColor="rgba(255,255,255,0.5)"
                     />
                     <View marginBottom="10px">
                        <Text
                           fontFamily="replica-mono"
                           transform="uppercase"
                           size="0.9"
                           letterSpacing="2px"
                           weight="medium"
                           lineHeight="150%"
                           color="rgba(255,255,255,1)">
                           Coming Soon
                        </Text>
                     </View>
                     <Text
                        fontFamily="classico-urw"
                        size="3"
                        lineHeight="150%"
                        color="rgba(255,255,255,0.7)">
                        {'We are a multidisciplinary design studio with a passion for crafting personal products that people use every day for life and work.'}
                     </Text>
                  </View>
               </View>
            </View>
         </View>
         {/* TODO: Use this when we improve website - PR #803
            <View>
            <Grid columns="4">
               <GridCell>
                  <View
                     position="relative"
                     padding="40px" textAlign="center">
                     <Text size="1" color="#aaa" transform="uppercase">
                        Release Notes
                     </Text>
                     <Text size="2.5" weight="medium" color="#000">
                        Gather version 5.11 released
                     </Text>
                     <Text size="2" color="#aaa">
                        March 8, 2021
                     </Text>
                  </View>
               </GridCell>
               <GridCell>
                  <View padding="40px" textAlign="center">
                     <Text size="1" color="#aaa" transform="uppercase">
                        Announcements
                     </Text>
                     <Text size="2.5" weight="medium" color="#000">
                        Building a new Future for apprenticeships in Alberta
                     </Text>
                     <Text size="2" color="#aaa">
                        March 8, 2021
                     </Text>
                  </View>
               </GridCell>
               <GridCell>
                  <View padding="40px" textAlign="center">
                     <Text size="1" color="#aaa" transform="uppercase">
                        Announcements
                     </Text>
                     <Text size="2.5" weight="medium" color="#000">
                        New Backpack coming soon
                     </Text>
                     <Text size="2" color="#aaa">
                        March 8, 2021
                     </Text>
                  </View>
               </GridCell>
            </Grid>
         </View> */}
      </View>
   )
}

export default MotherHome
